<template>
  <v-data-table
    item-key="education.key"
    :loading="loading"
    :headers="headers"
    :items="educations"
    :no-data-text="'Aucun'"
    indeterminate
    :items-per-page="1000"
    hide-default-footer
    dense
    v-if="educations.length"
  >
    <template v-slot:body="{ items }">
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>{{ item.year_end }}</td>
          <td>{{ item.duration }}</td>
          <td>{{ item.study_type }}</td>
          <td>{{ item.establishment }}</td>
          <td>{{ item.certificate_issued }}</td>
          <td class="spacy" v-if="!hideActions">
            <v-btn text icon color="green" @click="editItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn text icon color="red" @click="deleteItem(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </template>
  </v-data-table>
</template>
<script>
import Education from "@/models/Education"
import EducationForm from "@/components/educations/EducationForm"

export default {
  components: {
    EducationForm,
  },
  async mounted() {
    if (this.student_id) {
      await this.getDataFromApi()
    }
  },
  watch: {
    student_id: async function () {
      this.loading = true
      await this.getDataFromApi()
      this.loading = false
    },
  },
  props: {
    student_id: {
      required: true,
    },
    hideActions: {
      default: false,
    },
  },
  data: () => ({
    education: null,
    valid: false,
    errorMessages: "",
    panel: 0,
    loading: false,
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Ajouter une formation" : "Modifier une formation"
    },
    isDisabled() {
      return (
        !this.education.year ||
        !this.education.duration ||
        !this.education.study_type ||
        !this.education.establishment ||
        !this.education.certificate_issued
      )
    },
    headers() {
      let headers = [
        {
          text: "Date",
          value: "year_end",
          align: "left",
        },
        {
          text: "Durée",
          value: "duration",
          align: "left",
        },
        {
          text: "Type de formation",
          value: "study_type",
          align: "left",
        },
        {
          text: "Lieu de formation",
          value: "study_type",
        },
        {
          text: "Certificat délivré",
          value: "certificate_issued",
        },
      ]

      if (!this.hideActions) {
        headers.push({ text: "Actions", value: "name", sortable: false })
      }
      return headers
    },
    educations() {
      return Education.query().where("student_id", this.student_id).get()
    },
  },
  methods: {
    async getDataFromApi() {
      this.loading = true
      Education.getOneByStudentId(this.student_id)
      this.loading = false
    },
    editItem(education) {
      this.$emit("editEducation", education)
    },
    async deleteItem(education) {
      await Education.deleteOne(education.id)
      this.getDataFromApi()
    },
  },
}
</script>
